import React, { useState } from "react";

const days = [
  { day: 1, date: "May 8", title: "Introduction to HTML", status: "completed" },
  { day: 2, date: "May 9", title: "HTML Structure & Elements", status: "completed" },
  { day: 3, date: "May 10", title: "CSS Basics", status: "completed" },
  { day: 4, date: "May 11", title: "CSS Selectors & Properties", status: "completed" },
  { day: 5, date: "May 12", title: "CSS Layouts", status: "inprogress" },
  { day: 6, date: "May 13", title: "Responsive Design", status: "upcoming" },
  { day: 7, date: "May 14", title: "CSS Frameworks", status: "upcoming" },
  { day: 8, date: "May 15", title: "JavaScript Basics", status: "upcoming" },
  { day: 9, date: "May 16", title: "JavaScript Functions", status: "upcoming" },
  { day: 10, date: "May 17", title: "DOM Manipulation", status: "upcoming" },
  { day: 11, date: "May 18", title: "Event Handling", status: "upcoming" },
  { day: 12, date: "May 19", title: "JavaScript Objects", status: "upcoming" },
  { day: 13, date: "May 20", title: "JavaScript Arrays", status: "upcoming" },
  { day: 14, date: "May 21", title: "ES6+ Features", status: "upcoming" },
  { day: 15, date: "May 22", title: "Asynchronous JavaScript", status: "upcoming" },
  { day: 16, date: "May 23", title: "Fetch API & AJAX", status: "upcoming" },
  { day: 17, date: "May 24", title: "React Introduction", status: "upcoming" },
  { day: 18, date: "May 25", title: "React Components", status: "upcoming" },
  { day: 19, date: "May 26", title: "React Props & State", status: "upcoming" },
  { day: 20, date: "May 27", title: "React Hooks", status: "upcoming" },
  { day: 21, date: "May 28", title: "React Router", status: "upcoming" },
  { day: 22, date: "May 29", title: "State Management", status: "upcoming" },
  { day: 23, date: "May 30", title: "API Integration", status: "upcoming" },
  { day: 24, date: "May 31", title: "Form Handling", status: "upcoming" },
  { day: 25, date: "Jun 1", title: "Authentication", status: "upcoming" },
  { day: 26, date: "Jun 2", title: "Testing React Apps", status: "upcoming" },
  { day: 27, date: "Jun 3", title: "Performance Optimization", status: "upcoming" },
  { day: 28, date: "Jun 4", title: "Deployment", status: "upcoming" },
  { day: 29, date: "Jun 5", title: "Project Work", status: "upcoming" },
  { day: 30, date: "Jun 6", title: "Final Assessment", status: "upcoming" },
];

const glass = {
  background: "rgba(255,255,255,0.7)",
  boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.12)",
  backdropFilter: "blur(8px)",
  borderRadius: 18,
  border: "1px solid rgba(255,255,255,0.18)",
};

const DAYS_PER_PAGE = 18;

const Progress = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const completedDays = days.filter((d) => d.status === "completed").length;
  const progressPercent = Math.round((completedDays / days.length) * 100);

  // Pagination logic
  const totalPages = Math.ceil(days.length / DAYS_PER_PAGE);
  const startIdx = (currentPage - 1) * DAYS_PER_PAGE;
  const endIdx = startIdx + DAYS_PER_PAGE;
  const paginatedDays = days.slice(startIdx, endIdx);

  return (
    <div className="container-fluid py-4" style={{  minHeight: "100vh" }}>
      {/* Header */}
      <div className="mb-4">
        <h3 className="fw-bold" style={{ color: "#6d28d9", letterSpacing: 1 }}>Progress Tracker</h3>
        <div className="text-muted" style={{ marginTop: "-6px", fontSize: 16 }}>Track your progress through the internship program</div>
      </div>
      {/* Top Section */}
      <div className="row g-4 mb-4">
        {/* Overall Progress Card */}
        <div className="col-lg-6">
          <div className="card border-0 shadow-lg" style={{ ...glass, background: "linear-gradient(90deg, #6366f1 0%, #a21caf 100%)", color: "#fff" }}>
            <div className="card-body p-4">
              <div className="fw-semibold fs-5 mb-2">Overall Progress</div>
              <div className="mb-1" style={{ fontSize: 15 }}>{completedDays} of 30 days completed</div>
              <div className="d-flex align-items-center mb-3">
                <div className="flex-grow-1 me-2">
                  <div className="progress" style={{ height: 8, background: "rgba(255,255,255,0.25)", borderRadius: 6 }}>
                    <div className="progress-bar" role="progressbar" style={{ width: `${progressPercent}%`, background: "#fff", borderRadius: 6, boxShadow: "0 2px 8px #fff5" }} aria-valuenow={progressPercent} aria-valuemin={0} aria-valuemax={100}></div>
                  </div>
                </div>
                <span style={{ fontWeight: 600, fontSize: 15 }}>{progressPercent}%</span>
              </div>
              <div className="row g-3">
                <div className="col-6">
                  <div className="rounded-3 p-3 d-flex align-items-center gap-2" style={{ background: "rgba(99,102,241,0.12)", color: "#312e81" }}>
                    <i className="bi bi-journal-bookmark fs-4 text-primary"></i>
                    <div style={{ color:'#FFFFFF', }}>
                      <div className="small">Modules</div>
                      <div className="fw-bold fs-5">1 <span className="fw-normal" style={{ fontSize: 18, }}>/ 6</span></div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="rounded-3 p-3 d-flex align-items-center gap-2" style={{ background: "rgba(251,191,36,0.13)", color: "#92400e" }}>
                    <i className="bi bi-award fs-4 text-warning"></i>
                    <div style={{ color:'#FFFFFF', }}>
                      <div className="small">Certificates</div>
                      <div className="fw-bold fs-5">0 <span className="fw-normal" style={{ fontSize: 18 }}>/ 6</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Achievements Card */}
        <div className="col-lg-6">
          <div className="card border-0 shadow-lg" style={{ ...glass, background: "linear-gradient(120deg, #f8fafc 0%, #e0e7ff 100%)" }}>
            <div className="card-body p-4">
              <div className="fw-semibold fs-5 mb-2" style={{ color: "#f59e42" }}><span className="me-1"><i className="bi bi-star-fill"></i></span> Your Achievements</div>
              <div className="text-muted mb-3" style={{ fontSize: 14 }}>Certificates and badges you’ve earned</div>
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 160 }}>
                <div className="border border-2 border-dashed rounded-3 d-flex flex-column align-items-center justify-content-center" style={{ width: 220, height: 140, borderColor: "#e0e0e0", borderStyle: "dashed", background: "rgba(255,255,255,0.5)" }}>
                  <i className="bi bi-person fs-1 text-muted"></i>
                  <div className="text-muted" style={{ fontSize: 15 }}>Future Certificate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Daily Progress */}
      <div className="card border-0 shadow-lg mb-4" style={{ ...glass, background: "#f9fafb" }}>
        <div className="card-body p-4">
          <div className="fw-semibold fs-5 mb-3" style={{ color: "#3b3b3b" }}>Daily Progress</div>
          <div className="row g-3">
            {paginatedDays.map((d, idx) => {
              let bg = "#fff";
              let border = "#e0e0e0";
              let text = "#333";
              let icon = null;
              if (d.status === "completed") {
                bg = "#e6f9f0";
                border = "#b2f2e5";
                text = "#218c5b";
                icon = <i className="bi bi-check-circle-fill text-success"></i>;
              } else if (d.status === "inprogress") {
                bg = "#e7f0fa";
                border = "#b6d4fa";
                text = "#2563eb";
                icon = <i className="bi bi-arrow-repeat text-primary"></i>;
              } else if (d.status === "missed") {
                bg = "#fbdada";
                border = "#f5bebe";
                text = "#e11d48";
                icon = <i className="bi bi-x-circle-fill text-danger"></i>;
              } else if (d.status === "upcoming") {
                bg = "#f3f4f6";
                border = "#e5e7eb";
                text = "#6b7280";
                icon = <i className="bi bi-clock-history text-secondary"></i>;
              }
              return (
                <div className="col-xxl-2 col-lg-3 col-md-4 col-6" key={d.day}>
                  <div
                    className="rounded-3 p-3 h-100 shadow-sm border"
                    style={{ minHeight: 100, background: bg, borderColor: border, color: text, borderWidth: 2, borderStyle: "solid", transition: "box-shadow 0.2s" }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="fw-bold">Day {d.day}</span>
                      {icon}
                    </div>
                    <div className="text-muted" style={{ fontSize: 13 }}>{d.date}</div>
                    <div className="fw-semibold" style={{ fontSize: 15 }}>{d.title}</div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* Pagination Controls styled like Category.jsx */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="text-muted small">
              Showing {paginatedDays.length === 0 ? 0 : startIdx + 1} to {Math.min(endIdx, days.length)} of {days.length} days
            </div>
            <div className="d-flex align-items-center gap-2">
              <button
                className="btn btn-light btn-sm"
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &lt;
              </button>
              <span className="small">Page {currentPage} of {totalPages || 1}</span>
              <button
                className="btn btn-light btn-sm"
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
              >
                &gt;
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Legend */}
      <div className="card border-0 shadow-lg" style={{ ...glass, background: "#f9fafb" }}>
        <div className="card-body p-3">
          <div className="fw-semibold mb-2" style={{ color: "#3b3b3b" }}>Legend</div>
          <div className="d-flex flex-wrap gap-2">
  <span className="badge rounded-pill text-success d-flex align-items-center gap-1 px-3 py-2" style={{ backgroundColor: '#d1f2e9' }}>
    <i className="bi bi-check-circle-fill"></i> Completed
  </span>

  <span className="badge rounded-pill text-primary d-flex align-items-center gap-1 px-3 py-2" style={{ backgroundColor: '#d6e8fb' }}>
    <i className="bi bi-arrow-repeat"></i> In Progress
  </span>

  <span className="badge rounded-pill text-danger d-flex align-items-center gap-1 px-3 py-2" style={{ backgroundColor: '#fbdada' }}>
    <i className="bi bi-x-circle-fill"></i> Missed
  </span>

  <span className="badge rounded-pill text-secondary d-flex align-items-center px-3 py-2" style={{ backgroundColor: '#e5e7eb' }}>
    <i className="bi bi-clock-history"></i> Upcoming
  </span>

  <span className="badge rounded-pill text-warning d-flex align-items-center gap-1 px-3 py-2" style={{ backgroundColor: '#fff4cc' }}>
    <i className="bi bi-award"></i> Certificate
  </span>
</div>

        </div>
      </div>
    </div>
  );
};

export default Progress;